
export default class ListUtil {

    static toReadableOrList(items) {
        return items.join(', ').replace(/,([^,]*)$/, ' or$1');
    }
}